module.exports = __webpack_public_path__ + "img/android-logo.b88afa37.svg";